export const aboutContent = {
  hb_about: [
    <>
      Hardcore Buddhist is a Netherlands based multi-genre electronic music
      project that transcends stylistic boundaries, seamlessly blending
      chill-out moods with danceable progressive rhythms and psychedelic tones.
      The project officially started in 2016, but my journey with electronic
      sound production began in 2007.
    </>,
    <>
      The debut album "Being Nothing" was released in 2017 on Vertigo Records,
      followed by the "Chill Pepper" EP on Mystic Sound Records in 2019. That
      same year, I joined Cosmicleaf Records with the release of my album
      "Cosmic Mentality", marking the beginning of a long-term collaboration.
      Since then, Cosmicleaf has become my home label, where I've released the
      majority of my music. In April 2023, I released my latest album, Succulent
      432Hz. You can also find my solo tracks, collaborations, and remixes on
      Sentimony Records and Microcosmos Records. In April 2025, I launched my
      own label, Tweak Peak Records, dedicated to psybient, progressive
      chill-out, and psychedelic downtempo music.
    </>,
    <>
      Hardcore Buddhist's sound is a rich, emotionally charged journey through
      psybient, downtempo, progressive chill out, and psychill styles. Each
      composition weaves intricate sound design, dynamic energy shifts, and
      uplifting cosmic vibes, telling a trippy and exciting story infused with
      sassy, romantic, psychedelic, and oriental influences. Since 2016, I have
      been performing internationally, bringing my sound to audiences across
      Norway, Lithuania, Poland, Netherlands, Germany, Latvia, Romania, Czech
      Republic, Oman, and numerous festivals in Ukraine, my home country.
    </>,
    <>
      With multiple albums, EPs, and numerous collaborations with artists like
      Zero Cult, Lab's Cloud, Side Liner, Kick Bong, Dense, and Zymosis,
      Hardcore Buddhist is an ever-evolving project fueled by a passion for
      high-quality sound, guitar playing, and an insatiable desire to
      experiment.
    </>,
  ],
  swaratrip_about: [
    <>
      Swaratrip is my psychedelic trance project that explores the energetic
      spectrum of psytrance, fusing Goa Trance, Neo Goa, and Forest Psytrance
      into a hypnotic sonic experience. I founded it in 2015, driven by a deep
      passion for crafting a unique sound that bridges classic psychedelic
      influences with immersive storytelling. With over 15 years of experience
      in electronic music production and more than a decade of performing and
      releasing music, I’ve developed a personal style that aims to tell a story
      in every track.
    </>,
    <>
      In the early stages, Swaratrip focused on a forest goa vibe, shaped by my
      love for high-quality sound, experimentation, and the joy of sharing
      musical ideas. My inspirations include Glowing Flame Records, Vertigo
      Records, and Suntrip Records, as well as artists like Trold, Braincell,
      Man With No Name, Blue Planet Corporation, Cosmosis, Infected Mushroom,
      Atriohm, Archaic and many others. I’ve always aimed to blend melodic
      structure with powerful, driving rhythms to create music that resonates on
      a deeper level.
    </>,
    <>
      I played my first set in 2016, with only three of my own tracks at the
      time. Since then, I’ve released music on labels such as Neogoa Records,
      Timewarp, Vertigo Records, Space Baby Records, and Goa Records. Notable
      releases include the "Carnatic" EP on Timewarp Records in January 2018,
      and my full-length album "Twilight Patterns" on Neogoa Records in August
      2020. I've also had tracks featured on respected compilations from Vertigo
      Records and Skygravity Records, which I’m proud to be a part of. Over the
      years, I’ve collaborated with and remixed music by artists like Braincell,
      Blue Planet Corporation, Arta, Lacerta, Cosmic Dimension, Overdream,
      Alienapia, Sky Technology, and many others.
    </>,
    <>Two Sonic Dimensions of Swaratrip</>,
    <>
      Currently Swaratrip offers two distinct psychedelic experiences, tailored
      for different moments in a festival journey: Neo Goa / Forest Goa Trance –
      A deep, hypnotic, and driving experience rooted in the essence of classic
      Goa Trance. Forest Psytrance (Twilight & Morning) – A more organic,
      mysterious, and atmospheric take on Forest Psy, influenced by acts like
      Atriohm, Tengri, Archaic and Parvati Records.
    </>,
    <>
      Swaratrip has taken me to festivals and events in Norway, Netherlands,
      Latvia, Lithuania, Poland, Germany, Oman, Czech Republic, Romania, and
      many parties and festivals in my home country, Ukraine. I’ve had the honor
      of sharing the stage with artists such as Braincell, Atriohm, Goasia,
      Master Margherita, Blue Planet Corporation, Electric Universe, Ace
      Ventura, Atmos, Drip Drop, Fungus Funk, Whrick, Megalopsy, Dohm, Cosmic
      Vibration, and many more. With every track and every performance, my goal
      remains the same: to create deep, immersive journeys—whether through the
      cosmic pathways of Goa or the mysterious realms of the forest psy.
    </>,
  ],
  mindsex_about: [
    <>
      Mindsex is my newest project on the global electronic music scene — a
      boundary-pushing exploration of melodic house, techno, and progressive
      trance with a distinctive intelligent touch.
    </>,
    <>
      I’m Ihor Morozov, a music producer and composer born in Ukraine in 1982,
      now based in the Netherlands. With over 15 years of experience in
      electronic music production and a decade of releasing and performing live,
      I’ve worked across various styles with projects like Swaratrip (Goa and
      psytrance) and Hardcore Buddhist (psybient, downtempo, and progressive
      chill-out).
    </>,
    <>
      Mindsex is a natural evolution of my musical journey—built on depth,
      emotion, and detailed sound design. It’s a fusion of atmospheric melodies,
      hypnotic grooves, and progressive energy that aims to go beyond the
      mainstream and invite listeners into new, uncharted sonic territories.
    </>,
    <>
      To support and share this vision, I also founded Mindsex Music, a record
      label dedicated to deep, emotionally resonant, mid-tempo electronica. It's
      a space for those who crave more than just a beat—listeners who are drawn
      to immersive, thought-provoking journeys through sound.
    </>,
    <>
      This is Mindsex — where electronic music meets intelligence, depth, and
      evolution.
    </>,
  ],
};
